export default {
  title: 'Upload bank statements',
  paragraph: "Can't see your bank? Click below to upload your bank statements",
  button: 'Upload Statements'
};
